<template>
  <v-container>
    <v-card class="mx-auto rounded-xl">
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-4" elevation="4">
            <v-card-title>
              {{ isEditing ? 'Editar Imóvel' : 'Novo Imóvel' }}
            </v-card-title>
            <v-card-text>

              <v-tabs v-model="currentTab" dark class="mb-18">
                <v-tab value="details">Detalhes</v-tab>
                <v-tab value="photos">Fotos</v-tab>
              </v-tabs>

              <v-form ref="formRef" @submit.prevent="handleSubmit">
                <v-window v-model="currentTab" class="mt-2">
                  <v-window-item value="details">
                    <v-row class="mt-2">
                      <v-col cols="12" sm="2" v-if="isEditing">
                        <v-text-field :model-value="formattedCode" label="Código" :disabled="isEditing"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field v-model="formValue.title" label="Título" :rules="[rules.title]"></v-text-field>
                      </v-col>
                      <v-col sm="4">
                        <v-text-field v-model="priceFormatted" label="Preço (R$)" :rules="[rules.price]"
                          @input="formatInput"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-divider class="my-2"></v-divider>
                    <h4 class="text-h6 mb-4">Características</h4>
                    <v-row>
                      <v-col cols="12" sm="6" md="3">
                        <v-select v-model="formValue.operation" :items="operationOptions" item-title="label"
                          item-value="value" label="Operação" :rules="[rules.operation]"></v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-select v-model="formValue.type" :items="typeOptions" item-title="label" item-value="value"
                          label="Tipo de Imóvel" :rules="[rules.type]"></v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field v-model.number="formValue.bedrooms" label="Quartos" type="number"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field v-model.number="formValue.bathrooms" label="Banheiros"
                          type="number"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field v-model.number="formValue.suites" label="Suítes"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field v-model.number="formValue.garage" label="Vagas de Garagem"
                          type="number"></v-text-field>
                      </v-col>

                      <!-- IPTU -->
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="iptuFormatted" label="Valor do IPTU (R$)" @input="formatIptu"
                          :rules="[rules.iptu]"></v-text-field>
                      </v-col>

                      <!-- Periodicidade IPTU -->
                      <v-col cols="12" sm="6" md="4">
                        <v-select v-model="formValue.iptu_periodicity" :items="iptuPeriodicityOptions"
                          item-title="label" item-value="value" label="Periodicidade do IPTU"></v-select>
                      </v-col>
                    </v-row>
                    <v-divider class="my-2"></v-divider>
                    <h4 class="text-h6 mb-4">Áreas e Medidas (m²)</h4>
                    <v-row>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field v-model.number="formValue.total_area" label="Área Total"
                          type="number"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field v-model.number="formValue.usable_area" label="Área Útil"
                          type="number"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field v-model.number="formValue.built_area" label="Área Construída"
                          type="number"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field v-model.number="formValue.lot_area" label="Área do Terreno"
                          type="number"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field v-model.number="formValue.lot_front" label="Terreno (Frente)"
                          type="number"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field v-model.number="formValue.lot_back" label="Terreno (Fundo)"
                          type="number"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-divider class="my-2"></v-divider>
                    <h4 class="text-h6 mb-4">Endereço</h4>
                    <v-row>
                      <v-col cols="12" sm="6" md="2">
                        <v-text-field v-model="formValue.zip_code" v-maska="'#####-###'" label="CEP" @blur="consultaCEP"
                          :loading="isCepLoading"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="7">
                        <v-text-field v-model="formValue.address" label="Logradouro" 
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="formValue.number" label="Número"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="formValue.complement" label="Complemento"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="formValue.neighborhood" label="Bairro"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="formValue.city" label="Cidade" :rules="[rules.city]"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="1">
                        <v-text-field v-model="formValue.state" label="UF" ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea v-model="formValue.reference_point" label="Ponto de Referência"></v-textarea>
                      </v-col>
                    </v-row>
                    <v-divider class="my-2"></v-divider>
                    <h4 class="text-h6 mb-4">Informações de Contato e Venda</h4>
                    <v-row>
                      <!-- Cliente -->
                      <v-col cols="12" sm="6" md="4">
                        <v-select v-model="formValue.client_id" :items="clientOptions" item-title="label"
                          item-value="value" label="Cliente"></v-select>
                      </v-col>

                      <v-col cols="12" sm="6" md="6">
                        <v-btn v-if="formValue.client_id" color="primary" variant="flat" size="large"
                          @click="goToClientEdit(formValue.client_id)" :disabled="!formValue.client_id">
                          <v-icon start>mdi-account-edit</v-icon>
                          Ver Dados do Cliente
                        </v-btn>

                        <v-alert v-else type="info" density="compact" variant="tonal" class="text-caption"
                          :icon="false">
                          Selecione um cliente para editar.
                        </v-alert>
                      </v-col>

                      <!-- Corretor Responsável -->
                      <v-col cols="12" sm="6" md="4">
                        <v-select v-model="formValue.user_id" :items="brokers" item-title="name" item-value="id"
                          label="Corretor Responsável"></v-select>
                      </v-col>

                      <!-- Corretor Sugerido -->
                      <!--<v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="formValue.responsible_broker" label="Corretor Sugerido"></v-text-field>
                      </v-col>

                      <!-- Telefone do Corretor Sugerido -->
                      <!--<v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="formValue.responsible_broker_phone" v-maska="'(##) #####-####'"
                          label="Telefone do Corretor Sugerido"></v-text-field>
                      </v-col>-->

                      <!-- Switches -->
                      <v-col cols="12" sm="6" md="3">
                        <v-switch v-model="formValue.is_active" color="success" label="Imóvel Ativo?"></v-switch>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-switch v-model="formValue.is_reserved" color="warning" label="Imóvel Reservado?"></v-switch>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-switch v-model="formValue.is_launch" color="warning" label="Lançamento?"></v-switch>
                      </v-col>
                    </v-row>


                    <v-divider class="my-2"></v-divider>
                    <h4 class="text-h6 mb-4">Informações Adicionais</h4>
                    <v-row>
                      <v-col cols="12">
                        <v-textarea v-model="formValue.description" label="Descrição"></v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea v-model="formValue.highlights" label="Pontos Fortes"
                          hint="Digite cada ponto forte em uma nova linha."></v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-select v-model="formValue.features" :items="featureOptions" item-title="label"
                          item-value="value" label="Características do Imóvel" multiple chips></v-select>
                      </v-col>
                    </v-row>
                  </v-window-item>

                  <v-window-item value="photos">
                    <v-row>
                      <v-col cols="12">
                        <h4 class="text-h6 mb-4">Foto Principal</h4>
                        <v-file-input label="Selecione a foto principal" accept="image/png, image/jpeg, image/jpg"
                          prepend-icon="mdi-camera" v-model="mainImage" show-size>
                        </v-file-input>

                        <div v-if="mainImagePreview" class="relative">
                          <v-img :src="mainImagePreview" height="200px" contain class="mb-4 rounded-lg" />
                          <v-icon icon="mdi-close-circle" color="red" size="28"
                            class="absolute top-2 right-2 cursor-pointer bg-white rounded-full shadow-md"
                            @click="removeMainImage" />
                        </div>
                      </v-col>

                      <v-col cols="12">
                        <h4 class="text-h6 mb-4">Outras Fotos</h4>
                        <v-file-input label="Selecione as outras fotos" chips multiple show-size
                          accept="image/png, image/jpeg, image/jpg" :rules="[rules.maxImageSize]" v-model="otherImages">
                        </v-file-input>

                        <div v-if="allOtherImagePreviews.length" class="d-flex flex-wrap gap-2 mt-4">
                          <div v-for="(img, index) in allOtherImagePreviews" :key="img.url"
                            class="relative inline-block">
                            <v-img :src="img.url" height="100px" width="150px" contain class="rounded-lg" />
                            <v-icon icon="mdi-close-circle" color="red" size="24"
                              class="absolute top-1 right-1 cursor-pointer bg-white rounded-full"
                              @click="removeOtherImage(index)" />
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-window-item>

                </v-window>
              </v-form>
            </v-card-text>

            <v-card-actions class="d-flex justify-space-between">
              <v-btn color="secondary" variant="flat" @click="handleCancel">
                <v-icon left>mdi-arrow-left</v-icon>
                Voltar
              </v-btn>
              <v-btn color="primary" variant="flat" :loading="isSubmitting" :disabled="isSubmitting"
                @click="handleSubmit">
                <v-icon left>mdi-content-save</v-icon>
                {{ isEditing ? 'Salvar Alterações' : 'Cadastrar Imóvel' }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

  </v-container>
</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { vMaska } from "maska/vue";
import api from '@/services/api';
import { useToastStore } from '@/store/toast';
import { useLoadingOverlay } from '@/store/loadingOverlay';

const toastStore = useToastStore();
const loadingOverlay = useLoadingOverlay();
const route = useRoute();
const router = useRouter();
const formRef = ref(null);

const userData = ref(null);
const isLoading = ref(false);
const isSubmitting = ref(false);
const isCepLoading = ref(false);
const app_url_api_storage = process.env.VUE_APP_URL_API_STORAGE;

const currentTab = ref('details');

const mainImage = ref(null);
const otherImages = ref([]);
const existingMainImageUrl = ref('');
const existingOtherImages = ref([]);
const imagesToDelete = ref([]);
const brokers = ref([]);

const formValue = ref({
  title: '',
  code: '',
  description: '',
  operation: null,
  type: null,
  year: null,
  price: null,
  bedrooms: null,
  bathrooms: null,
  suites: null,
  garage: null,
  area: null,
  address: '',
  number: '',
  complement: '',
  neighborhood: '',
  city: '',
  state: '',
  zip_code: '',
  responsible_broker: '',
  responsible_broker_phone: '',
  client_id: null,
  status: null,
  is_active: true,
  is_reserved: false,
  is_launch: false,
  iptu_value: null,
  iptu_periodicity: null,
  total_area: null,
  usable_area: null,
  built_area: null,
  lot_area: null,
  lot_front: null,
  lot_back: null,
  features: [],
  highlights: '',
  reference_point: '',
});

const priceFormatted = ref('');
const iptuFormatted = ref('');
const isEditing = computed(() => !!route.params.id);

const operationOptions = [
  { label: 'Locação', value: 'rent' },
  { label: 'Venda', value: 'sale' },
  { label: 'Venda e Locação', value: 'both' },
];

const statusOptions = [
  { label: 'Em Análise', value: 'in_analysis' },
  { label: 'Aprovado', value: 'approved' },
  { label: 'Rejeitado', value: 'rejected' },
];

const typeOptions = [
  { label: 'Apartamento', value: 'apartment' },
  { label: 'Casa', value: 'house' },
  { label: 'Terreno', value: 'land' },
  { label: 'Comercial', value: 'commercial' },
  { label: 'Rural', value: 'rural' },
];

const iptuPeriodicityOptions = [
  { label: 'Mensal', value: 'monthly' },
  { label: 'Anual', value: 'annually' },
  { label: 'Pagamento Único', value: 'single_payment' },
];

const featureOptions = [
  { label: 'Aceita pet', value: 'pet_friendly' },
  { label: 'Armários', value: 'closets' },
  { label: 'Local tranquilo', value: 'calm_location' },
  { label: 'Piso Frio', value: 'cold_floor' },
  { label: 'Quintal', value: 'backyard' },
  { label: 'Ventilador', value: 'fan' },
  { label: 'Área de Serviço', value: 'service_area' },
  { label: 'Cozinha', value: 'kitchen' },
  { label: 'Escola Próxima', value: 'near_school' },
  { label: 'Farmácia Próxima', value: 'near_pharmacy' },
  { label: 'Piscina', value: 'pool' },
  { label: 'Churrasqueira', value: 'grill' },
  { label: 'Quadra de Futebol', value: 'football_court' },
  { label: 'Quadra de Vôlei', value: 'volleyball_court' },
  { label: 'Quadra de Tênis', value: 'tennis_court' },
  { label: 'Quadra de Esporte', value: 'sports_court' },
];

const clientOptions = ref([]);

const rules = {
  title: v => !!v || 'O título é obrigatório.',
  code: v => !!v || 'O código é obrigatório.',
  operation: v => !!v || 'A operação é obrigatória.',
  status: v => !!v || 'A situação é obrigatória.',
  type: v => !!v || 'O tipo é obrigatório.',
  price: () => (formValue.value.price !== null && formValue.value.price !== undefined && formValue.value.price >= 0) || 'O preço é obrigatório.',
  iptu: () => formValue.value.iptu_value === null || formValue.value.iptu_value >= 0 || 'O valor do IPTU não pode ser negativo.',
  /*address: v => !!v || 'O endereço é obrigatório.',
  neighborhood: v => !!v || 'O bairro é obrigatório.',*/
  city: v => !!v || 'A cidade é obrigatória.',
  /*state: v => !!v || 'O estado é obrigatório.',
  zip_code: v => !!v || 'O CEP é obrigatório.',*/
  maxImageSize: v => !v || v.every(file => file.size < 15 * 1024 * 1024) || 'Cada imagem deve ter no máximo 15MB.',
};

const loadClients = async () => {
  try {
    const response = await api.get('/clients');
    clientOptions.value = response.data.data.map(client => ({
      label: client.name,
      value: client.id,
    }));
  } catch (error) {
    console.error('Erro ao carregar a lista de clientes:', error);
    toastStore.showToast({
      message: error?.response?.data?.error || 'Erro ao carregar a lista de clientes',
      color: 'error',
    });
  }
};

const loadProperty = async (id) => {
  isLoading.value = true;
  loadingOverlay.startLoading();
  try {
    let response = null;
    if (userData.value.user.role === 'broker') {
      response = await api.get(`/properties/${id}`, {
        params: {
          broker_id: userData.value.user.id
        }
      });
    } else {
      response = await api.get(`/properties/${id}`);
    }

    const data = response.data.data;

    if (data) {
      formValue.value = {
        ...formValue.value,
        ...data,
        price: parseFloat(data.price),
        is_active: data.is_active === 1,
        is_reserved: data.is_reserved === 1,
        ready_to_build: data.ready_to_build === 1,
        is_launch: data.is_launch === 1,
        // Carregamento dos novos campos
        iptu_value: parseFloat(data.iptu_value).toFixed(2),
        features: data.features ? JSON.parse(data.features) : [],
      };

      if (data.images && data.images.length > 0) {
        existingMainImageUrl.value = app_url_api_storage + '/images/' + data.images[0];

        existingOtherImages.value = data.images.slice(1).map(img => app_url_api_storage + '/images/' + img);
      } else {
        existingMainImageUrl.value = '';
        existingOtherImages.value = [];
      }

      priceFormatted.value = formValue.value.price
        ? new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(formValue.value.price)
        : "";

      iptuFormatted.value = formValue.value.iptu_value
        ? new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(formValue.value.iptu_value)
        : "";

      await nextTick();
      if (formRef.value) {
        formRef.value.resetValidation();
      }
    } else {
      toastStore.showToast({
        message: 'O imóvel não foi encontrado.',
        color: 'warning',
      });
    }

  } catch (error) {
    console.error('Erro ao carregar os dados do imóvel:', error);
    toastStore.showToast({
      message: error?.response?.data?.error || 'Erro ao carregar os dados do imóvel',
      color: 'error',
    });
  } finally {
    isLoading.value = false;
    loadingOverlay.stopLoading();
  }
};

const mainImagePreview = computed(() => {
  if (mainImage.value) {
    return URL.createObjectURL(mainImage.value);
  }
  return existingMainImageUrl.value;
});

const allOtherImagePreviews = computed(() => {
  const existing = existingOtherImages.value.map(url => ({ url, isExisting: true }));

  const newImages = otherImages.value.map(file => ({
    url: URL.createObjectURL(file),
    isExisting: false,
    file: file
  }));

  return [...existing, ...newImages];
});

const removeMainImage = () => {
  if (existingMainImageUrl.value) {
    imagesToDelete.value.push(existingMainImageUrl.value.replace(app_url_api_storage + '/', ''));
  }
  existingMainImageUrl.value = '';
  mainImage.value = null;
};

const removeOtherImage = (index) => {
  const img = allOtherImagePreviews.value[index];

  if (img.isExisting) {
    imagesToDelete.value.push(img.url.replace(app_url_api_storage + '/', ''));
    existingOtherImages.value.splice(existingOtherImages.value.indexOf(img.url), 1);
  } else {
    const fileIndex = otherImages.value.findIndex(file => file === img.file);
    if (fileIndex !== -1) {
      otherImages.value.splice(fileIndex, 1);
    }
  }
};

const formattedCode = computed(() => {
  if (isEditing.value) {
    return formatCode(formValue.value);
  }
  return '';
});

const handleSubmit = async () => {
  const { valid } = await formRef.value.validate();
  if (!valid) {
    currentTab.value = 'details';
    return;
  }

  isSubmitting.value = true;

  const formData = new FormData();

  for (const key in formValue.value) {
    if (typeof formValue.value[key] === 'boolean') {
      formData.append(key, formValue.value[key] ? 1 : 0);
    } else if (formValue.value[key] !== null && formValue.value[key] !== undefined) {
      if (key === 'features') {
        formData.append(key, JSON.stringify(formValue.value[key]));
      } else {
        formData.append(key, formValue.value[key]);
      }
    }
  }

  if (mainImage.value) {
    formData.append('mainImage', mainImage.value);
  }
  otherImages.value.forEach((file, index) => {
    formData.append(`otherImages[${index}]`, file);
  });

  if (imagesToDelete.value.length > 0) {
    formData.append('imagesToDelete', JSON.stringify(imagesToDelete.value));
  }

  try {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };

    if (isEditing.value) {
      formData.append('_method', 'PUT');
      await api.post(`/properties/${route.params.id}`, formData, config);
    } else {
      await api.post('/properties', formData, config);
    }

    router.push('/app/imoveis');
    toastStore.showToast({
      message: isEditing.value ? 'Imóvel atualizado com sucesso!' : 'Imóvel cadastrado com sucesso!',
      color: 'success',
    });

  } catch (error) {
    isSubmitting.value = false;
    console.error('Erro ao salvar imóvel:', error);
    toastStore.showToast({
      message: error?.response?.data?.error || 'Erro ao salvar imóvel',
      color: 'error',
    });
  }
};


async function consultaCEP() {
  const cep = formValue.value.zip_code ? formValue.value.zip_code.replace(/\D/g, '') : null;
  if (!cep || cep.length !== 8) {
    return;
  }

  isCepLoading.value = true;

  try {
    const response = await api.get(`/cep`, {
      params: { cep: cep }
    });

    if (response.data && !response.data.erro) {
      formValue.value.address = response.data.logradouro;
      formValue.value.neighborhood = response.data.bairro;
      formValue.value.city = response.data.localidade;
      formValue.value.state = response.data.uf;
      toastStore.showToast({
        message: 'CEP encontrado com sucesso!',
        color: 'success',
      });
    } else {
      toastStore.showToast({
        message: 'CEP não encontrado. Por favor, preencha o endereço manualmente.',
        color: 'warning',
      });
    }
  } catch (error) {
    console.error("Erro na consulta de CEP:", error);
    toastStore.showToast({
      message: error?.response?.data?.error || 'Erro na consulta de CEP',
      color: 'error',
    });
  } finally {
    isCepLoading.value = false;
  }
}

const handleCancel = () => {
  router.push('/app/imoveis');
};

const formatInput = (event) => {
  const clean = event.target.value.replace(/\D/g, "");
  const num = parseInt(clean, 10) / 100;

  formValue.value.price = isNaN(num) ? null : num;

  priceFormatted.value = formValue.value.price
    ? new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(formValue.value.price)
    : "";
};

const formatIptu = (event) => {
  const clean = event.target.value.replace(/\D/g, "");

  if (clean.length === 0) {
    formValue.value.iptu_value = null;
    iptuFormatted.value = "";
    return;
  }
  if (parseInt(clean, 10) === 0) {
    formValue.value.iptu_value = 0;
  } else {
    const num = parseInt(clean, 10) / 100;
    formValue.value.iptu_value = isNaN(num) ? null : num;
  }

  iptuFormatted.value = formValue.value.iptu_value !== null
    ? new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(formValue.value.iptu_value)
    : "";
};

function formatCode(property) {
  let code = null;
  if (property.operation === 'rent') {
    code = 'L-';
  } else if (property.operation === 'sale') {
    code = 'V-';
  } else if (property.operation === 'launch') {
    code = 'LA-';
  } else if (property.operation === 'both') {
    code = 'VL-';
  } else {
    code = '';
  }

  code = code + property.id + '-' + property.year;

  return code;
}

const loadBrokers = async () => {
  isLoading.value = true;
  try {
    const response = await api.get('/brokers', {
      params: {
        role: ['leadbroker', 'adminbroker', 'broker']
      }
    });

    brokers.value = response.data.data;
  } catch (error) {
    console.error('Erro ao carregar corretores:', error);
    toastStore.showToast({
      message: error?.response?.data?.error || 'Ocorreu um erro ao carregar a lista de corretores.',
      color: 'error',
    });
  } finally {
    isLoading.value = false;
  }
};

const BASE_ROUTE_PATH = '/app/clientes/editar/';
function goToClientEdit(clientId) {
  if (clientId) {
    const url = `${BASE_ROUTE_PATH}${clientId}`;

    window.open(url, '_blank');
  }
}

onMounted(() => {
  const storedData = localStorage.getItem('userData');
  if (storedData) {
    userData.value = JSON.parse(storedData);
  }

  loadBrokers();
  loadClients();
  if (isEditing.value) {
    loadProperty(route.params.id);
  }
});

watch(
  () => formValue.value.price,
  (newValue) => {
    if (newValue !== null && typeof newValue === 'number') {
      priceFormatted.value = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(newValue);
    }
  }, { immediate: true }
);

</script>